import type { ComponentType } from 'react';
import DailyMenuFlowScreen from '../../dailyMenu/DailyMenuFlowScreen';
import FoodDailyMenuFlowScreen from '../../foodDailyMenu/FoodDailyMenuFlowScreen';
import MenuFlowScreen from '../../menu/MenuFlowScreen';
import FoodMenuFlowScreen from '../../foodMenu/FoodMenuFlowScreen';

/** Resolved from `menu_page_style`: type1 / type2 / type3 / type4. */
export type MenuTabFlowKind = 'classic_menu' | 'daily_menu' | 'food_menu' | 'food_daily_menu';
export type MenuTabBarIconFlow = 'classic' | 'daily';

/** Menu tab component from `menu_page_style` flow kind. */
export function resolveMenuTabComponent(flow_kind: MenuTabFlowKind | undefined): ComponentType {
  if (flow_kind === 'daily_menu') {
    return DailyMenuFlowScreen;
  }
  if (flow_kind === 'food_menu') {
    return FoodMenuFlowScreen;
  }
  if (flow_kind === 'food_daily_menu') {
    return FoodDailyMenuFlowScreen;
  }
  return MenuFlowScreen;
}

export function resolveMenuTabIconFlow(flow_kind: MenuTabFlowKind | undefined): MenuTabBarIconFlow | undefined {
  if (flow_kind === 'daily_menu' || flow_kind === 'food_daily_menu') {
    return 'daily';
  }
  if (flow_kind === 'classic_menu' || flow_kind === 'food_menu') {
    return 'classic';
  }
  return undefined;
}

export function isFoodMenuFlowKind(flow_kind: MenuTabFlowKind | undefined): boolean {
  return flow_kind === 'food_menu' || flow_kind === 'food_daily_menu';
}
